<template>
  <b-modal
    v-model="modalShow"
    title="Editar Plano"
    size="xl"
    scrollable
    no-close-on-esc
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok.prevent="onSubmit"
    @hidden="onHidden"
  >
    <div v-if="loading" class="p-4 text-center text-muted">Carregando...</div>
    <b-tabs v-else-if="strategic_plan" pills card vertical class="edit-menu-sidebar">
      <b-tab title="Dados Básicos" active>
        <DadosBasicos ref="dados_basicos" />
      </b-tab>
      <b-tab title="Estrutura">
        <OrdemEstrutura />
      </b-tab>
      <b-tab title="Configurações">
        <Configuracoes />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { DadosBasicos, Configuracoes, OrdemEstrutura } from "../Forms";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: { DadosBasicos, Configuracoes, OrdemEstrutura },
  data: () => ({
    modalShow: false,
    loading: false,
    planId: null,
  }),
  computed: {
    ...mapState("strategic_plans", ["strategic_plan", "tree_plan_structure"]),
    ...mapGetters("strategic_plans", ["getPayLoadPlanStructure"]),
  },
  methods: {
    ...mapActions("strategic_plans", [
      "ActionShow",
      "ActionSave",
      "ActionSaveTreeStructure",
      "ActionLoadPlanStructure",
    ]),
    async show(planId) {
      this.planId = planId;
      this.loading = true;
      this.modalShow = true;
      try {
        await this.ActionShow({ id: planId });
        await this.ActionLoadPlanStructure();
      } finally {
        this.loading = false;
      }
    },
    async onSubmit() {
      const isValid = this.$refs.dados_basicos?.isValid?.() ?? true;
      if (!isValid) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
        return;
      }
      try {
        await this.ActionSave(this.strategic_plan);
        if (!this.strategic_plan.initial_bsc_structure) {
          await this.ActionSaveTreeStructure(this.getPayLoadPlanStructure);
        }
        this.$notifications.addNotification({
          message: "Registro salvo com sucesso",
          type: "success",
        });
        this.modalShow = false;
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao salvar",
          type: "danger",
        });
      }
    },
    async onHidden() {
      if (this.planId) {
        await this.ActionShow({ id: this.planId });
        await this.ActionLoadPlanStructure();
      }
    },
  },
};
</script>
